import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "components";
import Footer from "components/footer";
import { Formik, ErrorMessage, Field, Form } from "formik";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import api from "services/api";
import * as Yup from "yup";

export const SetPassword = () => {
  const [loader, setLoader] = useState(false);
  const [showPasswordOld, setShowPasswordOld] = useState(false);
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordCon, setShowPasswordCon] = useState(false);

  const initialValues = {
    old_password: "",
    new_password: "",
    new_password_confirmation: "",
  };

  const validationSchema = Yup.object().shape({
    old_password: Yup.string()
      .required("Password is Required")
      .min(8, "Password must be at least 8 characters")
      .max(30, "Password must be at most 30 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      ),
    new_password: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters")
      .max(30, "Password must be at most 30 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      ),
    new_password_confirmation: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Confirm password is required")
      .min(8, "Password must be at least 8 characters")
      .max(30, "Password must be at most 30 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      ),
  });

  const handleOnSubmit = async (values, resetForm) => {
    setLoader(true);
    // Handle form submission
    console.log(values);
    const payload = {
      ...values,
    };

    try {
      const response = await api.post("/change-password", payload);
      console.log("setPassword:", response);
      if(response?.status === 200){
        toast.success(response?.data?.message);
        setLoader(false);
        resetForm();
      } else {
        toast.error(response?.data?.message);
        setLoader(false);

      }
      
    } catch (error) {
      let message = error?.response?.data?.message;
      console.log("Reset ERROR", message);
      toast.error(message);
      setLoader(false);
    }
  };

  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb" className="ms-4">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="#">Security</Link>
              </li>
              <li class="breadcrumb-item active">Reset password</li>
            </ol>
          </nav>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) =>
              handleOnSubmit(values, resetForm)
            }
          >
            {({ errors }) => (
              <Form>
                {/* {console.log("errors:",errors)} */}
                <div className="card mb-4 mx-4">
                  <h5 className="card-header">Please fill your details</h5>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-4 col-12">
                        <label for="old_password" className="form-label">
                          Type your old password{" "}
                          <span className="invalid-form">*</span>
                        </label>
                        <div className="input-group input-group-merge ">
                          <Field
                            type={showPasswordOld ? "text" : "password"}
                            name="old_password"
                            className="form-control"
                            placeholder="••••••••••••"
                            autoFocus
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowPasswordOld(!showPasswordOld)}
                            style={{ cursor: "pointer" }}
                          >
                            <FontAwesomeIcon
                              icon={showPasswordOld ? faEyeSlash : faEye}
                            />
                          </span>
                        </div>

                        <ErrorMessage
                          name="old_password"
                          component="div"
                          className="invalid-form"
                        />
                      </div>
                      <div className="col-md-4 col-12">
                        <label for="new_password" className="form-label">
                          Set new password
                          <span className="invalid-form">*</span>
                        </label>
                        <div className="input-group input-group-merge ">
                          <Field
                            type={showPasswordNew ? "text" : "password"}
                            name="new_password"
                            className="form-control"
                            placeholder="••••••••••••"
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowPasswordNew(!showPasswordNew)}
                            style={{ cursor: "pointer" }}
                          >
                            <FontAwesomeIcon
                              icon={showPasswordNew ? faEyeSlash : faEye}
                            />
                          </span>
                        </div>

                        <ErrorMessage
                          name="new_password"
                          component="div"
                          className="invalid-form"
                        />
                      </div>
                      <div className="col-md-4 col-12">
                        <label
                          for="new_password_confirmation"
                          className="form-label"
                        >
                          Confirm new password{" "}
                          <span className="invalid-form">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <Field
                            type={showPasswordCon ? "text" : "password"}
                            name="new_password_confirmation"
                            className="form-control"
                            placeholder="••••••••••••"
                          />
                          <span
                            className="input-group-text"
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPasswordCon(!showPasswordCon)}
                          >
                            <FontAwesomeIcon
                              icon={showPasswordCon ? faEyeSlash : faEye}
                            />
                          </span>
                        </div>

                        <ErrorMessage
                          name="new_password_confirmation"
                          component="div"
                          className="invalid-form"
                        />
                      </div>
                    </div>
                    <div className="mt-2">
                      {loader ? (
                        <button
                          type="button"
                          className="spinner-border text-primary"
                        >
                          <span class="visually-hidden">Loading...</span>
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <Footer />
        <div className="content-backdrop fade"></div>
      </div>
    </Container>
  );
};
